"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const ViewZeroDistro_vue_1 = __importDefault(require("./ViewZeroDistro.vue"));
const ParcelShape_vue_1 = __importDefault(require("@becrop/components/Common/ParcelShape.vue"));
const parcel_1 = __importDefault(require("../controllers/services/parcel"));
const ColorLibController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ColorLibController"));
let ListAverage = class ListAverage extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.colorManager = new ColorLibController_1.default();
    }
    calculateCategory(score) {
        if (score)
            return this.colorManager.getCategoryFromScore(score);
        return '';
    }
    categoryTransform(category) {
        if (category)
            return this.colorManager.getAlphaCategory(category);
        return '';
    }
    calculateCSSClasses(category) {
        if (category)
            return this.colorManager.getCSSClassesForCategory(category);
        return '';
    }
    parcelSvg(polygon) {
        return (0, parcel_1.default)(polygon, 55, 55);
    }
    get itemm() {
        return { parcel: true };
    }
    filterTopTwoAverages(data) {
        data.sort((a, b) => b.value - a.value);
        return data.slice(3);
    }
    get itemsAverage() {
        var _a;
        const itemsAverage = [];
        for (const item of this.items) {
            itemsAverage.push({
                icon: item.meta.cropLogo,
                name: item.meta.label,
                contentText: 'Avg',
                value: item.statistics.avg,
                category: null,
                current: false,
                polygon: item.meta.polygon,
            });
        }
        itemsAverage.push({
            icon: null,
            name: (_a = this.currentAverage.area) === null || _a === void 0 ? void 0 : _a.areaName,
            contentText: 'Score',
            value: this.currentAverage.score,
            category: this.currentAverage.category,
            current: true,
            polygon: '',
        });
        return itemsAverage;
    }
    diferrentAverage(currentAverage, secontAverage) {
        if (currentAverage > secontAverage) {
            return '-' + (currentAverage - secontAverage).toFixed(2);
        }
        if (currentAverage < secontAverage) {
            return '+' + (secontAverage - currentAverage).toFixed(2);
        }
        return '0';
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], ListAverage.prototype, "items", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], ListAverage.prototype, "currentAverage", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'crop' })
], ListAverage.prototype, "dimension", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ListAverage.prototype, "viewZero", void 0);
ListAverage = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            List: bmk_ui_framework_1.List,
            ListItem: bmk_ui_framework_1.ListItem,
            ParcelShape: ParcelShape_vue_1.default,
            ListIcon: bmk_ui_framework_1.ListIcon,
            ViewZeroDistro: ViewZeroDistro_vue_1.default,
        },
    })
], ListAverage);
exports.default = ListAverage;
